import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


// export const loggedInUser = null;


@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  public authLoggedInUser; // = loggedInUser;
  private endPointBaseurl: string;

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      Accept: 'application/json'
    }),
    // params: undefined,
  };

  constructor(
    private http: HttpClient,
    ) {
    this.endPointBaseurl = environment.appApiUrl;
  }


  public login(userInfo: any /*User*/) {
    const body = JSON.stringify(userInfo);
    return this.http.post(this.endPointBaseurl + 'login/authenticate', body, this.httpOptions);
  }

  public register(userInfo: any /*RegistrationUser*/) {
    const body = JSON.stringify(userInfo);
    return this.http.post(this.endPointBaseurl + 'instance/register', body, this.httpOptions);
  }

  public validateEmail(username: string /*Registration Form Email Address*/) {
    const params = new HttpParams().set('userName', username);
    const httpOptions = { ...this.httpOptions, params };
    return this.http.get(this.endPointBaseurl + 'instance/validate', httpOptions)
      .pipe(
        map((value: any) => {
          let emailExists: any;
          emailExists = value.Data;
          return emailExists;
        })
      );
  }

  public validateRegisterToken(token) {
    const params = new HttpParams().set('token', token);
    const httpOptions = { ...this.httpOptions, params };
    return this.http.post(this.endPointBaseurl + 'instance/register/token/validate', null, httpOptions);
  }

  public changeInstance(appInstanceGroupId: number, loggedInAccessToken) {
    const body = JSON.stringify(appInstanceGroupId);
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        accessToken: loggedInAccessToken
      },
    };
    return this.http.post(this.endPointBaseurl + 'instance', body, httpOptions);
  }

  public activateAccount(token) {
    const params = new HttpParams().set('guid', token);
    const httpOptions = { ...this.httpOptions, params };
    return this.http.post(this.endPointBaseurl + 'instance/activate', null, httpOptions);
  }


  public isLoggedIn() {
    this.ensureLoggedinUserIsSet();
    return this.authLoggedInUser != null;

  }


  public logout() {
    switch (environment.storageType) {
      case 'sessionStorage':
        sessionStorage.removeItem('LOGGEDIN_USER');
        break;
      case 'localStorage':
      default:
        localStorage.removeItem('LOGGEDIN_USER');
        break;
    }
    this.authLoggedInUser = null;
  }


  public get userInfo(): any {
    this.ensureLoggedinUserIsSet();
    return this.authLoggedInUser;
    // return this.isLoggedIn() ? JSON.parse(localStorage.getItem('LOGGEDIN_USER')) : null;
  }


  public set userInfo(userObj) {
    this.authLoggedInUser = userObj;
    switch (environment.storageType) {
      case 'sessionStorage':
        sessionStorage.setItem('LOGGEDIN_USER', JSON.stringify(userObj));
        break;
      case 'localStorage':
      default:
        localStorage.setItem('LOGGEDIN_USER', JSON.stringify(userObj));
        break;
    }
  }


  // Used to prevent parsing string from local storage all time when we want to access to user data.
  private ensureLoggedinUserIsSet() {
    if (this.authLoggedInUser == null) {
      switch (environment.storageType) {
        case 'sessionStorage':
          this.authLoggedInUser = JSON.parse(sessionStorage.getItem('LOGGEDIN_USER'));
          break;
        case 'localStorage':
        default:
          this.authLoggedInUser = JSON.parse(localStorage.getItem('LOGGEDIN_USER'));
          break;
      }
    }
  }


  public forgotPassword(email): Observable<any> {
    const bodyVal = JSON.stringify({ UserName: email, UrlforPasswordReset: location.origin + '/auth/reset-password' });
    return this.http.post(this.endPointBaseurl + 'password/forgot', bodyVal, this.httpOptions);
  }


  public passwordSave(passwordChangeToken: string, password: string): Observable<any> {
    const param = {
      Token: passwordChangeToken,
      Password: password
    };
    const bodyVal = param != null ? JSON.stringify(param) : null;
    return this.http.post(this.endPointBaseurl + 'password/save', bodyVal, this.httpOptions);
  }



  public requestOTPCode(requestInfo) {
    const body = JSON.stringify(requestInfo);
    return this.http.post(this.endPointBaseurl + 'login/requestOTPCode', body, this.httpOptions);
  }


  public validateOTPCode(validateInfo) {
    const body = JSON.stringify(validateInfo);
    return this.http.post(this.endPointBaseurl + 'login/validateOTPCode', body, this.httpOptions);
  }

}
